import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { truncateFileName } from '@carvana/purchase-utils';
import { ImageType } from '../../document-wizard.props';
import DocumentImage from '../document-image';
import * as documentPreviewStyles from './document-preview.styles';

const sc = { ...documentPreviewStyles };

const viewFullDocument = img => {
  const imgHtml = `<embed title=${img.name} src='${img.srcUrl}' type='${img.type}' />`;
  const imgWindow = window.open();

  imgWindow.document.write(imgHtml);
};

const DocumentPreview = ({ documentSelectOn, images, removeDocument }) => {
  const [activeSlideId, setActiveSlide] = useState(0);

  const PrevImgButton = () => {
    const disabled = activeSlideId === 0;

    return (
      <sc.PrevImgButton
        disabled={disabled}
        onClick={() => !disabled && setActiveSlide(activeSlideId - 1)}
      />
    );
  };

  const NextImgButton = () => {
    const disabled = activeSlideId === images.length - 1;

    return (
      <sc.NextImgButton
        disabled={disabled}
        onClick={() => !disabled && setActiveSlide(activeSlideId + 1)}
      />
    );
  };

  if (!images) return null;

  return (
    <sc.DocumentPreviewWrapper>
      <sc.Carousel>
        <sc.CarouselTrack
          className={`slide-${activeSlideId}-active`}
          slideCount={images.length}
        >
          {images.map((image, index) => {
            return (
              <DocumentImage
                className={`slide slide-${index}`}
                image={image}
                key={image.srcUrl}
              />
            );
          })}
        </sc.CarouselTrack>
      </sc.Carousel>
      {images.length > 1 && (
        <sc.ArrowButtonsWrapper>
          <PrevImgButton />
          <NextImgButton />
        </sc.ArrowButtonsWrapper>
      )}
      <sc.DocumentPreviewFooter>
        <sc.FullViewButton
          onClick={() => viewFullDocument(images[activeSlideId])}
        >
          Full View
        </sc.FullViewButton>
        <span css={sc.footerTextDividerStyles}>&#124;</span>
        <sc.FileName>
          {truncateFileName(images[activeSlideId].name, 26)}
        </sc.FileName>
        {documentSelectOn && (
          <sc.ReuploadButton onClick={() => {}}>Re-Upload</sc.ReuploadButton>
        )}
        {removeDocument && (
          <sc.ReuploadButton onClick={removeDocument}>Remove</sc.ReuploadButton>
        )}
      </sc.DocumentPreviewFooter>
    </sc.DocumentPreviewWrapper>
  );
};

DocumentPreview.propTypes = {
  documentSelectOn: PropTypes.bool,
  images: PropTypes.oneOfType([PropTypes.arrayOf(ImageType), ImageType])
    .isRequired,
  removeDocument: PropTypes.func
};

DocumentPreview.defaultProps = {
  documentSelectOn: false,
  removeDocument: null
};

export default DocumentPreview;
